<div class="min-h-screen bg-white-50">
  <router-outlet></router-outlet>
</div>
